export function formatNotificationDateTime(value, language = "sq") {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  return new Intl.DateTimeFormat(language === "sq" ? "sq-AL" : "en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function getNotificationNavigation(notification) {
  if (notification?.type === "PRODUCT_VARIANT_OUT_OF_STOCK") {
    return {
      path: `/admin/catalog/products/${notification.variant.productId}#inventory`,
      state: { notificationVariantId: notification.variant.variantId },
    };
  }

  return {
    path: `/admin/orders?orderId=${notification.order.id}`,
    state: { notificationOrderId: notification.order.id },
  };
}
